module.exports = __webpack_public_path__ + "img/clock.71a84833.svg";